/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/

import * as THREE from 'three'
import React, { useRef } from 'react'
import { useGLTF } from '@react-three/drei'
import { GLTF } from 'three/examples/jsm/loaders/GLTFLoader'

type GLTFResult = GLTF & {
  nodes: {
    map_8osm_buildings: THREE.Mesh
    map_8osm_buildings_1: THREE.Mesh
    map_8osm_buildings_2: THREE.Mesh
    map_8osm_buildings_3: THREE.Mesh
    map_8osm_buildings_4: THREE.Mesh
    map_8osm_buildings_5: THREE.Mesh
    element011: THREE.Mesh
    element011_1: THREE.Mesh
    Mast_1: THREE.Mesh
    Cube006_1: THREE.Mesh
    Mast_1001: THREE.Mesh
    Cube001: THREE.Mesh
    Mast_1002: THREE.Mesh
    Cube002: THREE.Mesh
    Mast_1003: THREE.Mesh
    Cube007_1: THREE.Mesh
    Blaaktoren_1: THREE.Mesh
    Blaaktoren_2: THREE.Mesh
    element002_1: THREE.Mesh
    element002_2: THREE.Mesh
    Centrale_Bibliotheek_1: THREE.Mesh
    Centrale_Bibliotheek_2: THREE.Mesh
    Centrale_Bibliotheek001_1: THREE.Mesh
    Centrale_Bibliotheek001_2: THREE.Mesh
    Centrale_Bibliotheek004: THREE.Mesh
    Centrale_Bibliotheek004_1: THREE.Mesh
    Cylinder: THREE.Mesh
    Cylinder001: THREE.Mesh
    Cylinder002: THREE.Mesh
    Cylinder003: THREE.Mesh
    Cylinder004: THREE.Mesh
    Cylinder005: THREE.Mesh
    Cylinder006: THREE.Mesh
    Cylinder007: THREE.Mesh
    Cylinder008: THREE.Mesh
    Cylinder009: THREE.Mesh
    Cylinder010: THREE.Mesh
    Cylinder011: THREE.Mesh
    Cylinder012: THREE.Mesh
    Cylinder013: THREE.Mesh
    Cylinder014: THREE.Mesh
    Cylinder015: THREE.Mesh
    Cylinder016: THREE.Mesh
    Cylinder017: THREE.Mesh
    Grass001: THREE.Mesh
    Rotterdam_Blaak_1: THREE.Mesh
    Rotterdam_Blaak_2: THREE.Mesh
    Cylinder018: THREE.Mesh
    Cylinder019: THREE.Mesh
    Cylinder020: THREE.Mesh
    Cylinder021: THREE.Mesh
    Cylinder022: THREE.Mesh
    Cylinder023: THREE.Mesh
    Cylinder024: THREE.Mesh
    Cylinder025: THREE.Mesh
    Cylinder055: THREE.Mesh
    Plane: THREE.Mesh
    Plane001: THREE.Mesh
    Markthal: THREE.Mesh
    Cube008_1: THREE.Mesh
    Cube010_1: THREE.Mesh
    Erasmusbrug: THREE.Mesh
    Cube003_1: THREE.Mesh
    Cylinder050: THREE.Mesh
    Cylinder051: THREE.Mesh
    Plane002_1: THREE.Mesh
    Car_1: THREE.Mesh
    Car_2: THREE.Mesh
    Car_3: THREE.Mesh
    Car_4: THREE.Mesh
    Car_5: THREE.Mesh
    Car001_1: THREE.Mesh
    Car001_2: THREE.Mesh
    Car001_3: THREE.Mesh
    Car001_4: THREE.Mesh
    Car001_5: THREE.Mesh
    Car002_1: THREE.Mesh
    Car002_2: THREE.Mesh
    Car002_3: THREE.Mesh
    Car002_4: THREE.Mesh
    Car002_5: THREE.Mesh
    water: THREE.Mesh
    Cube: THREE.Mesh
    Cube004: THREE.Mesh
    Cylinder056: THREE.Mesh
    Cylinder057: THREE.Mesh
    Cylinder058: THREE.Mesh
    Cylinder059: THREE.Mesh
    Cylinder060: THREE.Mesh
    Cylinder061: THREE.Mesh
    Cylinder069: THREE.Mesh
    Cylinder068: THREE.Mesh
    Cylinder067: THREE.Mesh
    Cylinder066: THREE.Mesh
    Cylinder070: THREE.Mesh
    Cylinder083: THREE.Mesh
    Cylinder082: THREE.Mesh
    Cylinder081: THREE.Mesh
    Cylinder080: THREE.Mesh
    Cylinder087: THREE.Mesh
    Cylinder086: THREE.Mesh
    Cylinder085: THREE.Mesh
    Cylinder084: THREE.Mesh
    Cylinder091: THREE.Mesh
    Cylinder090: THREE.Mesh
    Cylinder089: THREE.Mesh
    Cylinder088: THREE.Mesh
    Cylinder095: THREE.Mesh
    Cylinder094: THREE.Mesh
    Cylinder093: THREE.Mesh
    Cylinder092: THREE.Mesh
    Cylinder099: THREE.Mesh
    Cylinder098: THREE.Mesh
    Cylinder097: THREE.Mesh
    Cylinder096: THREE.Mesh
    Cylinder103: THREE.Mesh
    Cylinder102: THREE.Mesh
    Cylinder101: THREE.Mesh
    Cylinder100: THREE.Mesh
    Cylinder104: THREE.Mesh
    Car006_1: THREE.Mesh
    Car006_2: THREE.Mesh
    Car006_3: THREE.Mesh
    Car006_4: THREE.Mesh
    Car006_5: THREE.Mesh
    Cylinder105: THREE.Mesh
    Cube014: THREE.Mesh
    Cube015: THREE.Mesh
    Cube016: THREE.Mesh
    Cube017: THREE.Mesh
    Sphere020: THREE.Mesh
    Sphere021: THREE.Mesh
    Cylinder062: THREE.Mesh
    Cylinder063: THREE.Mesh
    Cylinder064: THREE.Mesh
    Cylinder065: THREE.Mesh
    Car003_1: THREE.Mesh
    Car003_2: THREE.Mesh
    Car003_3: THREE.Mesh
    Car003_4: THREE.Mesh
    Car003_5: THREE.Mesh
    Cylinder071: THREE.Mesh
    Car004_1: THREE.Mesh
    Car004_2: THREE.Mesh
    Car004_3: THREE.Mesh
    Car004_4: THREE.Mesh
    Car004_5: THREE.Mesh
    Cylinder079: THREE.Mesh
    Cylinder078: THREE.Mesh
    Cylinder077: THREE.Mesh
    Cylinder076: THREE.Mesh
    Car005_1: THREE.Mesh
    Car005_2: THREE.Mesh
    Car005_3: THREE.Mesh
    Car005_4: THREE.Mesh
    Car005_5: THREE.Mesh
    Cube018: THREE.Mesh
    Cube019: THREE.Mesh
    Cylinder072: THREE.Mesh
    Cylinder073: THREE.Mesh
    Cylinder074: THREE.Mesh
    Cylinder075: THREE.Mesh
    Cube011: THREE.Mesh
    Cube009: THREE.Mesh
    Sphere018: THREE.Mesh
    Cube013: THREE.Mesh
    Cube012: THREE.Mesh
    Sphere019: THREE.Mesh
    Car009_1: THREE.Mesh
    Car009_2: THREE.Mesh
    Car009_3: THREE.Mesh
    Car009_4: THREE.Mesh
    Car009_5: THREE.Mesh
    Car008_1: THREE.Mesh
    Car008_2: THREE.Mesh
    Car008_3: THREE.Mesh
    Car008_4: THREE.Mesh
    Car008_5: THREE.Mesh
    Car007_1: THREE.Mesh
    Car007_2: THREE.Mesh
    Car007_3: THREE.Mesh
    Car007_4: THREE.Mesh
    Car007_5: THREE.Mesh
    Cube025: THREE.Mesh
    Cube024: THREE.Mesh
    Cube023: THREE.Mesh
    Cube022: THREE.Mesh
    Cube021: THREE.Mesh
    Cube020: THREE.Mesh
    Cylinder114: THREE.Mesh
    Cylinder113: THREE.Mesh
    Cylinder112: THREE.Mesh
    Cylinder111: THREE.Mesh
    Cylinder110: THREE.Mesh
    Cylinder109: THREE.Mesh
    Cylinder108: THREE.Mesh
    Cylinder107: THREE.Mesh
    Cylinder106: THREE.Mesh
    Sphere023: THREE.Mesh
    Sphere022: THREE.Mesh
    Car012_1: THREE.Mesh
    Car012_2: THREE.Mesh
    Car012_3: THREE.Mesh
    Car012_4: THREE.Mesh
    Car012_5: THREE.Mesh
    Car011_1: THREE.Mesh
    Car011_2: THREE.Mesh
    Car011_3: THREE.Mesh
    Car011_4: THREE.Mesh
    Car011_5: THREE.Mesh
    Car010_1: THREE.Mesh
    Car010_2: THREE.Mesh
    Car010_3: THREE.Mesh
    Car010_4: THREE.Mesh
    Car010_5: THREE.Mesh
    Cube031: THREE.Mesh
    Cube030: THREE.Mesh
    Cube029: THREE.Mesh
    Cube028: THREE.Mesh
    Cube027: THREE.Mesh
    Cube026: THREE.Mesh
    Cylinder123: THREE.Mesh
    Cylinder122: THREE.Mesh
    Cylinder121: THREE.Mesh
    Cylinder120: THREE.Mesh
    Cylinder119: THREE.Mesh
    Cylinder118: THREE.Mesh
    Cylinder117: THREE.Mesh
    Cylinder116: THREE.Mesh
    Cylinder115: THREE.Mesh
    Sphere025: THREE.Mesh
    Sphere024: THREE.Mesh
    Car015_1: THREE.Mesh
    Car015_2: THREE.Mesh
    Car015_3: THREE.Mesh
    Car015_4: THREE.Mesh
    Car015_5: THREE.Mesh
    Car014_1: THREE.Mesh
    Car014_2: THREE.Mesh
    Car014_3: THREE.Mesh
    Car014_4: THREE.Mesh
    Car014_5: THREE.Mesh
    Car013_1: THREE.Mesh
    Car013_2: THREE.Mesh
    Car013_3: THREE.Mesh
    Car013_4: THREE.Mesh
    Car013_5: THREE.Mesh
    Cube037: THREE.Mesh
    Cube036: THREE.Mesh
    Cube035: THREE.Mesh
    Cube034: THREE.Mesh
    Cube033: THREE.Mesh
    Cube032: THREE.Mesh
    Cylinder132: THREE.Mesh
    Cylinder131: THREE.Mesh
    Cylinder130: THREE.Mesh
    Cylinder129: THREE.Mesh
    Cylinder128: THREE.Mesh
    Cylinder127: THREE.Mesh
    Cylinder126: THREE.Mesh
    Cylinder125: THREE.Mesh
    Cylinder124: THREE.Mesh
    Sphere027: THREE.Mesh
    Sphere026: THREE.Mesh
    Car018_1: THREE.Mesh
    Car018_2: THREE.Mesh
    Car018_3: THREE.Mesh
    Car018_4: THREE.Mesh
    Car018_5: THREE.Mesh
    Car017_1: THREE.Mesh
    Car017_2: THREE.Mesh
    Car017_3: THREE.Mesh
    Car017_4: THREE.Mesh
    Car017_5: THREE.Mesh
    Car016_1: THREE.Mesh
    Car016_2: THREE.Mesh
    Car016_3: THREE.Mesh
    Car016_4: THREE.Mesh
    Car016_5: THREE.Mesh
    Cube043: THREE.Mesh
    Cube042: THREE.Mesh
    Cube041: THREE.Mesh
    Cube040: THREE.Mesh
    Cube039: THREE.Mesh
    Cube038: THREE.Mesh
    Cylinder141: THREE.Mesh
    Cylinder140: THREE.Mesh
    Cylinder139: THREE.Mesh
    Cylinder138: THREE.Mesh
    Cylinder137: THREE.Mesh
    Cylinder136: THREE.Mesh
    Cylinder135: THREE.Mesh
    Cylinder134: THREE.Mesh
    Cylinder133: THREE.Mesh
    Sphere029: THREE.Mesh
    Sphere028: THREE.Mesh
    Car021_1: THREE.Mesh
    Car021_2: THREE.Mesh
    Car021_3: THREE.Mesh
    Car021_4: THREE.Mesh
    Car021_5: THREE.Mesh
    Car020_1: THREE.Mesh
    Car020_2: THREE.Mesh
    Car020_3: THREE.Mesh
    Car020_4: THREE.Mesh
    Car020_5: THREE.Mesh
    Car019_1: THREE.Mesh
    Car019_2: THREE.Mesh
    Car019_3: THREE.Mesh
    Car019_4: THREE.Mesh
    Car019_5: THREE.Mesh
    Cube049: THREE.Mesh
    Cube048: THREE.Mesh
    Cube047: THREE.Mesh
    Cube046: THREE.Mesh
    Cube045: THREE.Mesh
    Cube044: THREE.Mesh
    Cylinder150: THREE.Mesh
    Cylinder149: THREE.Mesh
    Cylinder148: THREE.Mesh
    Cylinder147: THREE.Mesh
    Cylinder146: THREE.Mesh
    Cylinder145: THREE.Mesh
    Cylinder144: THREE.Mesh
    Cylinder143: THREE.Mesh
    Cylinder142: THREE.Mesh
    Sphere031: THREE.Mesh
    Sphere030: THREE.Mesh
    Cube005: THREE.Mesh
    Cylinder054: THREE.Mesh
    Cylinder053: THREE.Mesh
    Cylinder052: THREE.Mesh
    Sphere003: THREE.Mesh
    Sphere: THREE.Mesh
    Sphere001: THREE.Mesh
    Sphere002: THREE.Mesh
    Sphere004: THREE.Mesh
    Sphere005: THREE.Mesh
    Sphere009: THREE.Mesh
    Sphere006: THREE.Mesh
    Sphere007: THREE.Mesh
    Sphere008: THREE.Mesh
    Sphere010: THREE.Mesh
    Sphere011: THREE.Mesh
    Sphere015: THREE.Mesh
    Sphere012: THREE.Mesh
    Sphere013: THREE.Mesh
    Sphere014: THREE.Mesh
    Sphere016: THREE.Mesh
    Sphere017: THREE.Mesh
  }
  materials: {
    b0e0e6: THREE.MeshStandardMaterial
    ['000000']: THREE.MeshStandardMaterial
    ffffff: THREE.MeshStandardMaterial
    c0c0c0: THREE.MeshStandardMaterial
    f0f8ff: THREE.MeshStandardMaterial
    dcdcdc: THREE.MeshStandardMaterial
    roof: THREE.MeshStandardMaterial
    wall: THREE.MeshStandardMaterial
    ['wall.001']: THREE.MeshStandardMaterial
    grey: THREE.MeshStandardMaterial
    ['roof.001']: THREE.MeshStandardMaterial
    ['wall.005']: THREE.MeshStandardMaterial
    ['roof.005']: THREE.MeshStandardMaterial
    ['wall.007']: THREE.MeshStandardMaterial
    ['roof.007']: THREE.MeshStandardMaterial
    ['wall.008']: THREE.MeshStandardMaterial
    ['roof.008']: THREE.MeshStandardMaterial
    ['Library Buis']: THREE.MeshStandardMaterial
    ['Material.002']: THREE.MeshStandardMaterial
    ['wall.006']: THREE.MeshStandardMaterial
    ['roof.006']: THREE.MeshStandardMaterial
    Material: THREE.MeshStandardMaterial
    ['Material.007']: THREE.MeshStandardMaterial
    ['Material.005']: THREE.MeshStandardMaterial
    ['Material.009']: THREE.MeshStandardMaterial
    bridgewhite: THREE.MeshStandardMaterial
    ['Material.001']: THREE.MeshStandardMaterial
    streetblack: THREE.MeshStandardMaterial
    Steel_1: THREE.MeshStandardMaterial
    White: THREE.MeshStandardMaterial
    Black_Matte: THREE.MeshStandardMaterial
    Cabin: THREE.MeshStandardMaterial
    Steel: THREE.MeshStandardMaterial
    ['Steel_1.001']: THREE.MeshStandardMaterial
    ['White.001']: THREE.MeshStandardMaterial
    ['Black_Matte.001']: THREE.MeshStandardMaterial
    ['Cabin.001']: THREE.MeshStandardMaterial
    ['Steel.001']: THREE.MeshStandardMaterial
    ['Steel_1.002']: THREE.MeshStandardMaterial
    ['White.002']: THREE.MeshStandardMaterial
    ['Black_Matte.002']: THREE.MeshStandardMaterial
    ['Cabin.002']: THREE.MeshStandardMaterial
    ['Steel.002']: THREE.MeshStandardMaterial
    water: THREE.MeshStandardMaterial
    Dirt: THREE.MeshStandardMaterial
    ['Material.006']: THREE.MeshStandardMaterial
    ['Material.008']: THREE.MeshStandardMaterial
    ['Material.010']: THREE.MeshStandardMaterial
    ['Material.011']: THREE.MeshStandardMaterial
    ['Material.012']: THREE.MeshStandardMaterial
    ['Material.013']: THREE.MeshStandardMaterial
    ['Material.021']: THREE.MeshStandardMaterial
    ['Material.020']: THREE.MeshStandardMaterial
    ['Material.019']: THREE.MeshStandardMaterial
    ['Material.018']: THREE.MeshStandardMaterial
    ['Material.022']: THREE.MeshStandardMaterial
    ['Material.035']: THREE.MeshStandardMaterial
    ['Material.034']: THREE.MeshStandardMaterial
    ['Material.033']: THREE.MeshStandardMaterial
    ['Material.032']: THREE.MeshStandardMaterial
    ['Material.039']: THREE.MeshStandardMaterial
    ['Material.038']: THREE.MeshStandardMaterial
    ['Material.037']: THREE.MeshStandardMaterial
    ['Material.036']: THREE.MeshStandardMaterial
    ['Material.043']: THREE.MeshStandardMaterial
    ['Material.042']: THREE.MeshStandardMaterial
    ['Material.041']: THREE.MeshStandardMaterial
    ['Material.040']: THREE.MeshStandardMaterial
    ['Material.047']: THREE.MeshStandardMaterial
    ['Material.046']: THREE.MeshStandardMaterial
    ['Material.045']: THREE.MeshStandardMaterial
    ['Material.044']: THREE.MeshStandardMaterial
    ['Material.051']: THREE.MeshStandardMaterial
    ['Material.050']: THREE.MeshStandardMaterial
    ['Material.049']: THREE.MeshStandardMaterial
    ['Material.048']: THREE.MeshStandardMaterial
    ['Material.055']: THREE.MeshStandardMaterial
    ['Material.054']: THREE.MeshStandardMaterial
    ['Material.053']: THREE.MeshStandardMaterial
    ['Material.052']: THREE.MeshStandardMaterial
    ['Material.056']: THREE.MeshStandardMaterial
    ['Steel_1.006']: THREE.MeshStandardMaterial
    ['White.006']: THREE.MeshStandardMaterial
    ['Black_Matte.006']: THREE.MeshStandardMaterial
    ['Cabin.006']: THREE.MeshStandardMaterial
    ['Steel.006']: THREE.MeshStandardMaterial
    ['Material.057']: THREE.MeshStandardMaterial
    ['Material.060']: THREE.MeshStandardMaterial
    ['Material.061']: THREE.MeshStandardMaterial
    ['Material.014']: THREE.MeshStandardMaterial
    ['Material.015']: THREE.MeshStandardMaterial
    ['Material.016']: THREE.MeshStandardMaterial
    ['Material.017']: THREE.MeshStandardMaterial
    ['Steel_1.003']: THREE.MeshStandardMaterial
    ['White.003']: THREE.MeshStandardMaterial
    ['Black_Matte.003']: THREE.MeshStandardMaterial
    ['Cabin.003']: THREE.MeshStandardMaterial
    ['Steel.003']: THREE.MeshStandardMaterial
    ['Material.023']: THREE.MeshStandardMaterial
    ['Steel_1.004']: THREE.MeshStandardMaterial
    ['White.004']: THREE.MeshStandardMaterial
    ['Black_Matte.004']: THREE.MeshStandardMaterial
    ['Cabin.004']: THREE.MeshStandardMaterial
    ['Steel.004']: THREE.MeshStandardMaterial
    ['Material.031']: THREE.MeshStandardMaterial
    ['Material.030']: THREE.MeshStandardMaterial
    ['Material.029']: THREE.MeshStandardMaterial
    ['Material.028']: THREE.MeshStandardMaterial
    ['Steel_1.005']: THREE.MeshStandardMaterial
    ['White.005']: THREE.MeshStandardMaterial
    ['Black_Matte.005']: THREE.MeshStandardMaterial
    ['Cabin.005']: THREE.MeshStandardMaterial
    ['Steel.005']: THREE.MeshStandardMaterial
    trunk: THREE.MeshStandardMaterial
    ['trunk.001']: THREE.MeshStandardMaterial
    ['Material.024']: THREE.MeshStandardMaterial
    ['Material.025']: THREE.MeshStandardMaterial
    ['Material.026']: THREE.MeshStandardMaterial
    ['Material.027']: THREE.MeshStandardMaterial
    ['Material.058']: THREE.MeshStandardMaterial
    ['Material.059']: THREE.MeshStandardMaterial
    ['Steel_1.009']: THREE.MeshStandardMaterial
    ['White.009']: THREE.MeshStandardMaterial
    ['Black_Matte.009']: THREE.MeshStandardMaterial
    ['Cabin.009']: THREE.MeshStandardMaterial
    ['Steel.009']: THREE.MeshStandardMaterial
    ['Steel_1.008']: THREE.MeshStandardMaterial
    ['White.008']: THREE.MeshStandardMaterial
    ['Black_Matte.008']: THREE.MeshStandardMaterial
    ['Cabin.008']: THREE.MeshStandardMaterial
    ['Steel.008']: THREE.MeshStandardMaterial
    ['Steel_1.007']: THREE.MeshStandardMaterial
    ['White.007']: THREE.MeshStandardMaterial
    ['Black_Matte.007']: THREE.MeshStandardMaterial
    ['Cabin.007']: THREE.MeshStandardMaterial
    ['Steel.007']: THREE.MeshStandardMaterial
    ['Material.063']: THREE.MeshStandardMaterial
    ['Material.062']: THREE.MeshStandardMaterial
    ['trunk.003']: THREE.MeshStandardMaterial
    ['trunk.002']: THREE.MeshStandardMaterial
    ['Material.072']: THREE.MeshStandardMaterial
    ['Material.071']: THREE.MeshStandardMaterial
    ['Material.070']: THREE.MeshStandardMaterial
    ['Material.069']: THREE.MeshStandardMaterial
    ['Material.068']: THREE.MeshStandardMaterial
    ['Material.067']: THREE.MeshStandardMaterial
    ['Material.066']: THREE.MeshStandardMaterial
    ['Material.065']: THREE.MeshStandardMaterial
    ['Material.064']: THREE.MeshStandardMaterial
    ['Steel_1.012']: THREE.MeshStandardMaterial
    ['White.012']: THREE.MeshStandardMaterial
    ['Black_Matte.012']: THREE.MeshStandardMaterial
    ['Cabin.012']: THREE.MeshStandardMaterial
    ['Steel.012']: THREE.MeshStandardMaterial
    ['Steel_1.011']: THREE.MeshStandardMaterial
    ['White.011']: THREE.MeshStandardMaterial
    ['Black_Matte.011']: THREE.MeshStandardMaterial
    ['Cabin.011']: THREE.MeshStandardMaterial
    ['Steel.011']: THREE.MeshStandardMaterial
    ['Steel_1.010']: THREE.MeshStandardMaterial
    ['White.010']: THREE.MeshStandardMaterial
    ['Black_Matte.010']: THREE.MeshStandardMaterial
    ['Cabin.010']: THREE.MeshStandardMaterial
    ['Steel.010']: THREE.MeshStandardMaterial
    ['Material.074']: THREE.MeshStandardMaterial
    ['Material.073']: THREE.MeshStandardMaterial
    ['trunk.005']: THREE.MeshStandardMaterial
    ['trunk.004']: THREE.MeshStandardMaterial
    ['Material.083']: THREE.MeshStandardMaterial
    ['Material.082']: THREE.MeshStandardMaterial
    ['Material.081']: THREE.MeshStandardMaterial
    ['Material.080']: THREE.MeshStandardMaterial
    ['Material.079']: THREE.MeshStandardMaterial
    ['Material.078']: THREE.MeshStandardMaterial
    ['Material.077']: THREE.MeshStandardMaterial
    ['Material.076']: THREE.MeshStandardMaterial
    ['Material.075']: THREE.MeshStandardMaterial
    ['Steel_1.015']: THREE.MeshStandardMaterial
    ['White.015']: THREE.MeshStandardMaterial
    ['Black_Matte.015']: THREE.MeshStandardMaterial
    ['Cabin.015']: THREE.MeshStandardMaterial
    ['Steel.015']: THREE.MeshStandardMaterial
    ['Steel_1.014']: THREE.MeshStandardMaterial
    ['White.014']: THREE.MeshStandardMaterial
    ['Black_Matte.014']: THREE.MeshStandardMaterial
    ['Cabin.014']: THREE.MeshStandardMaterial
    ['Steel.014']: THREE.MeshStandardMaterial
    ['Steel_1.013']: THREE.MeshStandardMaterial
    ['White.013']: THREE.MeshStandardMaterial
    ['Black_Matte.013']: THREE.MeshStandardMaterial
    ['Cabin.013']: THREE.MeshStandardMaterial
    ['Steel.013']: THREE.MeshStandardMaterial
    ['Material.085']: THREE.MeshStandardMaterial
    ['Material.084']: THREE.MeshStandardMaterial
    ['trunk.007']: THREE.MeshStandardMaterial
    ['trunk.006']: THREE.MeshStandardMaterial
    ['Material.094']: THREE.MeshStandardMaterial
    ['Material.093']: THREE.MeshStandardMaterial
    ['Material.092']: THREE.MeshStandardMaterial
    ['Material.091']: THREE.MeshStandardMaterial
    ['Material.090']: THREE.MeshStandardMaterial
    ['Material.089']: THREE.MeshStandardMaterial
    ['Material.088']: THREE.MeshStandardMaterial
    ['Material.087']: THREE.MeshStandardMaterial
    ['Material.086']: THREE.MeshStandardMaterial
    ['Steel_1.018']: THREE.MeshStandardMaterial
    ['White.018']: THREE.MeshStandardMaterial
    ['Black_Matte.018']: THREE.MeshStandardMaterial
    ['Cabin.018']: THREE.MeshStandardMaterial
    ['Steel.018']: THREE.MeshStandardMaterial
    ['Steel_1.017']: THREE.MeshStandardMaterial
    ['White.017']: THREE.MeshStandardMaterial
    ['Black_Matte.017']: THREE.MeshStandardMaterial
    ['Cabin.017']: THREE.MeshStandardMaterial
    ['Steel.017']: THREE.MeshStandardMaterial
    ['Steel_1.016']: THREE.MeshStandardMaterial
    ['White.016']: THREE.MeshStandardMaterial
    ['Black_Matte.016']: THREE.MeshStandardMaterial
    ['Cabin.016']: THREE.MeshStandardMaterial
    ['Steel.016']: THREE.MeshStandardMaterial
    ['Material.096']: THREE.MeshStandardMaterial
    ['Material.095']: THREE.MeshStandardMaterial
    ['trunk.009']: THREE.MeshStandardMaterial
    ['trunk.008']: THREE.MeshStandardMaterial
    ['Material.105']: THREE.MeshStandardMaterial
    ['Material.104']: THREE.MeshStandardMaterial
    ['Material.103']: THREE.MeshStandardMaterial
    ['Material.102']: THREE.MeshStandardMaterial
    ['Material.101']: THREE.MeshStandardMaterial
    ['Material.100']: THREE.MeshStandardMaterial
    ['Material.099']: THREE.MeshStandardMaterial
    ['Material.098']: THREE.MeshStandardMaterial
    ['Material.097']: THREE.MeshStandardMaterial
    ['Steel_1.021']: THREE.MeshStandardMaterial
    ['White.021']: THREE.MeshStandardMaterial
    ['Black_Matte.021']: THREE.MeshStandardMaterial
    ['Cabin.021']: THREE.MeshStandardMaterial
    ['Steel.021']: THREE.MeshStandardMaterial
    ['Steel_1.020']: THREE.MeshStandardMaterial
    ['White.020']: THREE.MeshStandardMaterial
    ['Black_Matte.020']: THREE.MeshStandardMaterial
    ['Cabin.020']: THREE.MeshStandardMaterial
    ['Steel.020']: THREE.MeshStandardMaterial
    ['Steel_1.019']: THREE.MeshStandardMaterial
    ['White.019']: THREE.MeshStandardMaterial
    ['Black_Matte.019']: THREE.MeshStandardMaterial
    ['Cabin.019']: THREE.MeshStandardMaterial
    ['Steel.019']: THREE.MeshStandardMaterial
    ['trunk.011']: THREE.MeshStandardMaterial
    ['trunk.010']: THREE.MeshStandardMaterial
    ['Material.116']: THREE.MeshStandardMaterial
    ['Material.115']: THREE.MeshStandardMaterial
    ['Material.114']: THREE.MeshStandardMaterial
    ['Material.113']: THREE.MeshStandardMaterial
    ['Material.112']: THREE.MeshStandardMaterial
    ['Material.111']: THREE.MeshStandardMaterial
    ['Material.110']: THREE.MeshStandardMaterial
    ['Material.109']: THREE.MeshStandardMaterial
    ['Material.108']: THREE.MeshStandardMaterial
    ['Material.107']: THREE.MeshStandardMaterial
    ['Material.106']: THREE.MeshStandardMaterial
    red: THREE.MeshStandardMaterial
    ['Material.004']: THREE.MeshStandardMaterial
    ['Material.003']: THREE.MeshStandardMaterial
    Smog: THREE.MeshStandardMaterial
  }
}

export default function CityBad(props: JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>()
  const { nodes, materials } = useGLTF('assets/models/cityBad.glb') as GLTFResult
  return (
    <group ref={group} {...props} dispose={null}>
      <group position={[-138.62, -25.33, -340.83]} scale={[1.15, 2.24, 1.15]}>
        <mesh geometry={nodes.map_8osm_buildings.geometry} material={materials.b0e0e6} />
        <mesh geometry={nodes.map_8osm_buildings_1.geometry} material={materials['000000']} />
        <mesh geometry={nodes.map_8osm_buildings_2.geometry} material={materials.ffffff} />
        <mesh geometry={nodes.map_8osm_buildings_3.geometry} material={materials.c0c0c0} />
        <mesh geometry={nodes.map_8osm_buildings_4.geometry} material={materials.f0f8ff} />
        <mesh geometry={nodes.map_8osm_buildings_5.geometry} material={materials.dcdcdc} />
      </group>
      <group position={[-275.42, -11.66, 231.89]} rotation={[0, -0.46, 0]} scale={[1.15, 2.24, 1.15]}>
        <mesh geometry={nodes.element011.geometry} material={materials.roof} />
        <mesh geometry={nodes.element011_1.geometry} material={materials.wall} />
        <mesh
          geometry={nodes.Mast_1.geometry}
          material={nodes.Mast_1.material}
          position={[61.98, 20.67, -200.86]}
          rotation={[0, -0.15, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube006_1.geometry}
            material={nodes.Cube006_1.material}
            position={[-0.66, 8.5, -0.37]}
            rotation={[Math.PI, -0.02, Math.PI]}
            scale={[-19.13, -0.01, -12.97]}
          />
        </mesh>
        <mesh
          geometry={nodes.Mast_1001.geometry}
          material={nodes.Mast_1001.material}
          position={[23.79, 21.75, 30.87]}
          rotation={[0, -0.15, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube001.geometry}
            material={nodes.Cube001.material}
            position={[0, 8.5, 0]}
            rotation={[Math.PI, 0, Math.PI]}
            scale={[-19.13, -0.01, -12.97]}
          />
        </mesh>
        <mesh
          geometry={nodes.Mast_1002.geometry}
          material={nodes.Mast_1002.material}
          position={[-50.11, 22.56, -137.17]}
          rotation={[0, 0.86, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube002.geometry}
            material={nodes.Cube002.material}
            position={[65.7, 7.85, 455.92]}
            rotation={[-Math.PI, 0, -Math.PI]}
            scale={[-19.13, -0.01, -12.97]}
          />
        </mesh>
        <mesh
          geometry={nodes.Mast_1003.geometry}
          material={nodes.Mast_1003.material}
          position={[151.69, 19.77, -19.14]}
          rotation={[0, 0.86, 0]}
          scale={[0.65, 4.8, 0.5]}>
          <mesh
            geometry={nodes.Cube007_1.geometry}
            material={nodes.Cube007_1.material}
            position={[-64.06, 8.97, -456.15]}
            rotation={[-Math.PI, 0.02, -Math.PI]}
            scale={[-23.31, -0.01, -16.48]}
          />
        </mesh>
      </group>
      <group position={[35.48, -16.01, -262.85]} scale={[1.15, 2.24, 1.15]}>
        <mesh geometry={nodes.Blaaktoren_1.geometry} material={nodes.Blaaktoren_1.material} />
        <mesh geometry={nodes.Blaaktoren_2.geometry} material={materials.grey} />
        <group position={[19.64, 0.11, -15]}>
          <mesh geometry={nodes.element002_1.geometry} material={nodes.element002_1.material} />
          <mesh geometry={nodes.element002_2.geometry} material={materials['roof.001']} />
        </group>
      </group>
      <group position={[160.62, 17.86, -256.15]} scale={[0.67, 2.24, 0.67]}>
        <mesh geometry={nodes.Centrale_Bibliotheek_1.geometry} material={materials['wall.005']} />
        <mesh geometry={nodes.Centrale_Bibliotheek_2.geometry} material={materials['roof.005']} />
        <group position={[26.74, -16.54, 0]}>
          <mesh geometry={nodes.Centrale_Bibliotheek001_1.geometry} material={materials['wall.007']} />
          <mesh geometry={nodes.Centrale_Bibliotheek001_2.geometry} material={materials['roof.007']} />
        </group>
        <group position={[0, 16.75, 0]} scale={[0.54, 0.38, 0.54]}>
          <mesh geometry={nodes.Centrale_Bibliotheek004.geometry} material={materials['wall.008']} />
          <mesh geometry={nodes.Centrale_Bibliotheek004_1.geometry} material={materials['roof.008']} />
        </group>
        <mesh
          geometry={nodes.Cylinder.geometry}
          material={nodes.Cylinder.material}
          position={[-61.97, 20.7, 20.08]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.92, 5.23, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder001.geometry}
          material={nodes.Cylinder001.material}
          position={[-69.13, 19.28, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder002.geometry}
          material={nodes.Cylinder002.material}
          position={[-54.03, 19.28, 17.27]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder003.geometry}
          material={nodes.Cylinder003.material}
          position={[-69.13, 13.31, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder004.geometry}
          material={nodes.Cylinder004.material}
          position={[-69.13, 7.26, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder005.geometry}
          material={nodes.Cylinder005.material}
          position={[-69.13, 1.64, 23.88]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder006.geometry}
          material={nodes.Cylinder006.material}
          position={[-64.37, 1.64, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder007.geometry}
          material={nodes.Cylinder007.material}
          position={[-64.37, 7.26, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder008.geometry}
          material={nodes.Cylinder008.material}
          position={[-64.37, 13.31, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder009.geometry}
          material={nodes.Cylinder009.material}
          position={[-49.28, 19.28, 28.41]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder010.geometry}
          material={nodes.Cylinder010.material}
          position={[-64.37, 19.28, 35.02]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder011.geometry}
          material={nodes.Cylinder011.material}
          position={[-57.21, 20.7, 31.23]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.92, 5.23, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder012.geometry}
          material={nodes.Cylinder012.material}
          position={[-26.5, 20.7, 38.78]}
          rotation={[-3.11, 1.26, -1.57]}
          scale={[1.92, 5.23, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder013.geometry}
          material={nodes.Cylinder013.material}
          position={[-23.07, 19.28, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder014.geometry}
          material={nodes.Cylinder014.material}
          position={[-28.91, 19.28, 30.71]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder015.geometry}
          material={nodes.Cylinder015.material}
          position={[-23.07, 13.31, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder016.geometry}
          material={nodes.Cylinder016.material}
          position={[-23.07, 7.26, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
        <mesh
          geometry={nodes.Cylinder017.geometry}
          material={nodes.Cylinder017.material}
          position={[-23.07, 1.64, 46.12]}
          rotation={[0, 1.52, 0]}
          scale={[3.3, 3.04, 3.3]}
        />
      </group>
      <mesh
        geometry={nodes.Grass001.geometry}
        material={materials['Material.002']}
        position={[-189.21, -2.29, 168.04]}
        rotation={[0, 0.06, 0]}
        scale={[-76.01, -43.4, 95.04]}
      />
      <group position={[-19.34, -11.33, -346.07]} scale={[1.15, 2.24, 1.15]}>
        <mesh geometry={nodes.Rotterdam_Blaak_1.geometry} material={materials['wall.006']} />
        <mesh geometry={nodes.Rotterdam_Blaak_2.geometry} material={materials['roof.006']} />
        <mesh
          geometry={nodes.Cylinder018.geometry}
          material={nodes.Cylinder018.material}
          position={[-19.93, 17.56, 10.03]}
          rotation={[0, 0.38, 1.6]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder019.geometry}
          material={nodes.Cylinder019.material}
          position={[-29.47, 16.21, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder020.geometry}
          material={nodes.Cylinder020.material}
          position={[1.37, 16.21, 0.91]}
          scale={[2.42, 1.69, 2.47]}
        />
        <mesh
          geometry={nodes.Cylinder021.geometry}
          material={nodes.Cylinder021.material}
          position={[-29.47, 10.24, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder022.geometry}
          material={nodes.Cylinder022.material}
          position={[-29.47, 4.19, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder023.geometry}
          material={nodes.Cylinder023.material}
          position={[-29.47, -1.43, 14.43]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder024.geometry}
          material={nodes.Cylinder024.material}
          position={[-25.3, 17.44, 12.22]}
          rotation={[0, 0.38, 1.6]}
          scale={[1.92, 3.04, 1.92]}
        />
        <mesh
          geometry={nodes.Cylinder025.geometry}
          material={nodes.Cylinder025.material}
          position={[-13.11, 17.63, 7.38]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.92, 5.08, 1.9]}
        />
        <mesh
          geometry={nodes.Cylinder055.geometry}
          material={nodes.Cylinder055.material}
          position={[-4.07, 17.75, 3.47]}
          rotation={[0, 0.37, 1.6]}
          scale={[1.92, 5.08, 1.9]}
        />
      </group>
      <mesh
        geometry={nodes.Plane.geometry}
        material={nodes.Plane.material}
        position={[29, -10.28, -313.4]}
        scale={[346.11, 2.24, 182.65]}
      />
      <mesh
        geometry={nodes.Plane001.geometry}
        material={nodes.Plane001.material}
        position={[26.46, -11.49, 154.14]}
        rotation={[0, 1.57, 0]}
        scale={[189, 0.4, 347.04]}
      />
      <mesh
        geometry={nodes.Markthal.geometry}
        material={materials['Material.007']}
        position={[304.26, 46.34, -327.37]}
        scale={[68.26, 62.22, 113.92]}>
        <mesh
          geometry={nodes.Cube008_1.geometry}
          material={materials['Material.005']}
          position={[0, 0, -0.03]}
          scale={[0.98, 0.97, 0.98]}
        />
        <mesh
          geometry={nodes.Cube010_1.geometry}
          material={materials['Material.009']}
          position={[0, 0, 0.02]}
          scale={[0.98, 0.97, 0.98]}
        />
      </mesh>
      <mesh
        geometry={nodes.Erasmusbrug.geometry}
        material={nodes.Erasmusbrug.material}
        position={[-34.08, -7.51, 13.19]}
        rotation={[Math.PI, -1.54, Math.PI]}
        scale={[12.87, 12.6, 6.02]}>
        <mesh geometry={nodes.Cube003_1.geometry} material={nodes.Cube003_1.material} position={[0, 0, -5.21]} />
        <mesh
          geometry={nodes.Cylinder050.geometry}
          material={materials['Material.001']}
          position={[6.26, 5.83, -8.42]}
          rotation={[0, 0, 0.36]}
          scale={[0.1, 7.14, 0.1]}
        />
        <mesh
          geometry={nodes.Cylinder051.geometry}
          material={nodes.Cylinder051.material}
          position={[6.25, 5.83, -2.89]}
          rotation={[0, 0, 0.36]}
          scale={[0.1, 7.14, 0.1]}
        />
        <mesh geometry={nodes.Plane002_1.geometry} material={materials.streetblack} position={[4.16, 0, -2.89]} />
      </mesh>
      <group position={[-27.72, -8.49, 30.23]} rotation={[1.59, 0, 0.84]} scale={[-0.09, 0.08, 0.06]}>
        <mesh geometry={nodes.Car_1.geometry} material={materials.Steel_1} />
        <mesh geometry={nodes.Car_2.geometry} material={materials.White} />
        <mesh geometry={nodes.Car_3.geometry} material={materials.Black_Matte} />
        <mesh geometry={nodes.Car_4.geometry} material={materials.Cabin} />
        <mesh geometry={nodes.Car_5.geometry} material={materials.Steel} />
      </group>
      <group position={[-23.09, -8.49, -147.02]} rotation={[1.59, 0, 0.84]} scale={[-0.09, 0.08, 0.06]}>
        <mesh geometry={nodes.Car001_1.geometry} material={materials['Steel_1.001']} />
        <mesh geometry={nodes.Car001_2.geometry} material={materials['White.001']} />
        <mesh geometry={nodes.Car001_3.geometry} material={materials['Black_Matte.001']} />
        <mesh geometry={nodes.Car001_4.geometry} material={materials['Cabin.001']} />
        <mesh geometry={nodes.Car001_5.geometry} material={materials['Steel.001']} />
      </group>
      <group position={[-27.72, -8.49, -262.19]} rotation={[1.57, -0.02, -0.81]} scale={[-0.09, 0.08, 0.06]}>
        <mesh geometry={nodes.Car002_1.geometry} material={materials['Steel_1.002']} />
        <mesh geometry={nodes.Car002_2.geometry} material={materials['White.002']} />
        <mesh geometry={nodes.Car002_3.geometry} material={materials['Black_Matte.002']} />
        <mesh geometry={nodes.Car002_4.geometry} material={materials['Cabin.002']} />
        <mesh geometry={nodes.Car002_5.geometry} material={materials['Steel.002']} />
      </group>
      <mesh
        geometry={nodes.water.geometry}
        material={materials.water}
        position={[19.05, -81.55, -68.03]}
        scale={[194.88, 55.79, 40.07]}
      />
      <mesh
        geometry={nodes.Cube.geometry}
        material={nodes.Cube.material}
        position={[28.23, -24.54, 152.68]}
        scale={[347.82, 12.58, 189.9]}
      />
      <mesh
        geometry={nodes.Cube004.geometry}
        material={nodes.Cube004.material}
        position={[28.23, -24.54, -313.14]}
        scale={[347.82, 12.58, 183.49]}
      />
      <mesh
        geometry={nodes.Cylinder056.geometry}
        material={materials['Material.006']}
        position={[-88.24, -18.63, -49.95]}
        rotation={[-1.55, 0.02, 0.87]}
        scale={[3.03, 3.37, 2.91]}
      />
      <mesh
        geometry={nodes.Cylinder057.geometry}
        material={materials['Material.008']}
        position={[186.8, -20.18, -108.07]}
        rotation={[-1.54, 0, 0]}
        scale={[3.46, 4.1, 2.78]}
      />
      <mesh
        geometry={nodes.Cylinder058.geometry}
        material={materials['Material.010']}
        position={[-291.85, -19.56, -96.94]}
        rotation={[-1.55, -0.02, -0.77]}
        scale={[3.13, 3.7, 2.44]}
      />
      <mesh
        geometry={nodes.Cylinder059.geometry}
        material={materials['Material.011']}
        position={[-156.31, -16.14, -73.73]}
        rotation={[-1.54, 0, 0]}
        scale={[3.3, 3.91, 2.84]}
      />
      <mesh
        geometry={nodes.Cylinder060.geometry}
        material={materials['Material.012']}
        position={[82.81, -20.31, -73.73]}
        rotation={[-1.55, -0.02, -0.94]}
        scale={[3.99, 4.72, 3.51]}
      />
      <mesh
        geometry={nodes.Cylinder061.geometry}
        material={materials['Material.013']}
        position={[322.69, -18.56, -46.81]}
        rotation={[-1.55, 0.02, 0.74]}
        scale={[3.48, 4.11, 3.05]}
      />
      <mesh
        geometry={nodes.Cylinder069.geometry}
        material={materials['Material.021']}
        position={[239.78, 2.21, 316.69]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[4.18, 4.81, 4.19]}
      />
      <mesh
        geometry={nodes.Cylinder068.geometry}
        material={materials['Material.020']}
        position={[240.51, -7.24, 313.78]}
        scale={[4.18, 4.79, 4.18]}
      />
      <mesh
        geometry={nodes.Cylinder067.geometry}
        material={materials['Material.019']}
        position={[244.7, -7.24, 319.25]}
        scale={[4.18, 4.79, 4.18]}
      />
      <mesh
        geometry={nodes.Cylinder066.geometry}
        material={materials['Material.018']}
        position={[236.05, -7.24, 319.25]}
        scale={[4.18, 4.79, 4.18]}
      />
      <mesh
        geometry={nodes.Cylinder070.geometry}
        material={materials['Material.022']}
        position={[-244.81, -19.56, -70.16]}
        rotation={[-1.54, 0.01, 0.29]}
        scale={[3.13, 3.7, 3.01]}
      />
      <mesh
        geometry={nodes.Cylinder083.geometry}
        material={materials['Material.035']}
        position={[-283.52, 7.55, 69.14]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[6.09, 6.11, 6.1]}
      />
      <mesh
        geometry={nodes.Cylinder082.geometry}
        material={materials['Material.034']}
        position={[-282.92, -5.3, 64.18]}
        scale={[6.09, 6.09, 6.09]}
      />
      <mesh
        geometry={nodes.Cylinder081.geometry}
        material={materials['Material.033']}
        position={[-276.81, -5.3, 72.14]}
        scale={[6.09, 6.09, 6.09]}
      />
      <mesh
        geometry={nodes.Cylinder080.geometry}
        material={materials['Material.032']}
        position={[-289.41, -5.3, 72.14]}
        scale={[6.09, 6.09, 6.09]}
      />
      <mesh
        geometry={nodes.Cylinder087.geometry}
        material={materials['Material.039']}
        position={[-242.94, 5.82, 304.33]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[6.24, 6.96, 6.25]}
      />
      <mesh
        geometry={nodes.Cylinder086.geometry}
        material={materials['Material.038']}
        position={[-243.15, -5.7, 302.77]}
        scale={[6.23, 6.93, 6.23]}
      />
      <mesh
        geometry={nodes.Cylinder085.geometry}
        material={materials['Material.037']}
        position={[-236.91, -5.7, 310.91]}
        scale={[6.23, 6.93, 6.23]}
      />
      <mesh
        geometry={nodes.Cylinder084.geometry}
        material={materials['Material.036']}
        position={[-249.8, -5.7, 310.91]}
        scale={[6.23, 6.93, 6.23]}
      />
      <mesh
        geometry={nodes.Cylinder091.geometry}
        material={materials['Material.043']}
        position={[223.13, 3.24, -433.32]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[4.47, 5.66, 4.48]}
      />
      <mesh
        geometry={nodes.Cylinder090.geometry}
        material={materials['Material.042']}
        position={[223.66, -6.14, -438.46]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder089.geometry}
        material={materials['Material.041']}
        position={[228.14, -6.14, -432.62]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder088.geometry}
        material={materials['Material.040']}
        position={[218.89, -6.14, -432.62]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder095.geometry}
        material={materials['Material.047']}
        position={[113.96, -6.14, -289.48]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder094.geometry}
        material={materials['Material.046']}
        position={[123.21, -6.14, -289.48]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder093.geometry}
        material={materials['Material.045']}
        position={[118.73, -6.14, -295.32]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder092.geometry}
        material={materials['Material.044']}
        position={[118.2, 3.24, -290.18]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[4.47, 5.66, 4.48]}
      />
      <mesh
        geometry={nodes.Cylinder099.geometry}
        material={materials['Material.051']}
        position={[-247.45, 3.24, -376.49]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[4.47, 5.66, 4.48]}
      />
      <mesh
        geometry={nodes.Cylinder098.geometry}
        material={materials['Material.050']}
        position={[-246.91, -6.14, -381.63]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder097.geometry}
        material={materials['Material.049']}
        position={[-242.43, -6.14, -375.79]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder096.geometry}
        material={materials['Material.048']}
        position={[-251.68, -6.14, -375.79]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder103.geometry}
        material={materials['Material.055']}
        position={[-127.44, 3.24, -325.68]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[4.47, 5.66, 4.48]}
      />
      <mesh
        geometry={nodes.Cylinder102.geometry}
        material={materials['Material.054']}
        position={[-126.91, -6.14, -330.83]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder101.geometry}
        material={materials['Material.053']}
        position={[-122.43, -6.14, -324.99]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder100.geometry}
        material={materials['Material.052']}
        position={[-131.68, -6.14, -324.99]}
        scale={[4.47, 5.65, 4.47]}
      />
      <mesh
        geometry={nodes.Cylinder104.geometry}
        material={materials['Material.056']}
        position={[-71.6, -20.81, -123.22]}
        rotation={[-1.57, -0.03, -1.65]}
        scale={[3.3, 3.91, 2.84]}
      />
      <group position={[121.68, -12.18, 257.93]} rotation={[1.57, -0.02, -0.77]} scale={[-0.09, 0.08, 0.06]}>
        <mesh geometry={nodes.Car006_1.geometry} material={materials['Steel_1.006']} />
        <mesh geometry={nodes.Car006_2.geometry} material={materials['White.006']} />
        <mesh geometry={nodes.Car006_3.geometry} material={materials['Black_Matte.006']} />
        <mesh geometry={nodes.Car006_4.geometry} material={materials['Cabin.006']} />
        <mesh geometry={nodes.Car006_5.geometry} material={materials['Steel.006']} />
      </group>
      <mesh
        geometry={nodes.Cylinder105.geometry}
        material={materials['Material.057']}
        position={[325.67, -23.47, -111.12]}
        rotation={[-1.55, -0.02, -0.94]}
        scale={[3.99, 4.72, 3.51]}
      />
      <mesh
        geometry={nodes.Cube014.geometry}
        material={nodes.Cube014.material}
        position={[-103.71, -14.08, -75.39]}
        rotation={[-0.92, 0.22, 1.52]}
        scale={[6.02, 4.29, 6.85]}
      />
      <mesh
        geometry={nodes.Cube015.geometry}
        material={nodes.Cube015.material}
        position={[-98.76, -11.05, -79.61]}
        rotation={[-0.71, 0, 0]}
        scale={[3.93, 6.73, 6.87]}
      />
      <mesh
        geometry={nodes.Cube016.geometry}
        material={nodes.Cube016.material}
        position={[19.04, -13.88, -82.32]}
        rotation={[0.74, 0, 0]}
        scale={[3.93, 6.73, 6.94]}
      />
      <mesh
        geometry={nodes.Cube017.geometry}
        material={nodes.Cube017.material}
        position={[14.09, -18.74, -84.62]}
        rotation={[0.53, 0.22, 1.52]}
        scale={[6.06, 3.97, 5.8]}
      />
      <mesh
        geometry={nodes.Sphere020.geometry}
        material={nodes.Sphere020.material}
        position={[-98.44, -18.2, -73.38]}
        rotation={[-0.93, 0, 0]}
        scale={[3.93, 6.01, 6.79]}
      />
      <mesh
        geometry={nodes.Sphere021.geometry}
        material={nodes.Sphere021.material}
        position={[19.36, -21.37, -88.19]}
        rotation={[0.52, 0, 0]}
        scale={[3.93, 6.03, 5.81]}
      />
      <mesh
        geometry={nodes.Cylinder062.geometry}
        material={materials['Material.014']}
        position={[234.57, -3.52, 106.18]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[3.03, 3.52, 3.03]}
      />
      <mesh
        geometry={nodes.Cylinder063.geometry}
        material={materials['Material.015']}
        position={[236.97, -9.35, 102.7]}
        scale={[3.02, 3.51, 3.02]}
      />
      <mesh
        geometry={nodes.Cylinder064.geometry}
        material={materials['Material.016']}
        position={[240, -9.35, 106.66]}
        scale={[3.02, 3.51, 3.02]}
      />
      <mesh
        geometry={nodes.Cylinder065.geometry}
        material={materials['Material.017']}
        position={[233.74, -9.35, 106.66]}
        scale={[3.02, 3.51, 3.02]}
      />
      <group position={[-253.71, -4.89, -469.17]} rotation={[-2.49, -0.02, -0.81]} scale={[-0.18, 0.15, 0.12]}>
        <mesh geometry={nodes.Car003_1.geometry} material={materials['Steel_1.003']} />
        <mesh geometry={nodes.Car003_2.geometry} material={materials['White.003']} />
        <mesh geometry={nodes.Car003_3.geometry} material={materials['Black_Matte.003']} />
        <mesh geometry={nodes.Car003_4.geometry} material={materials['Cabin.003']} />
        <mesh geometry={nodes.Car003_5.geometry} material={materials['Steel.003']} />
      </group>
      <mesh
        geometry={nodes.Cylinder071.geometry}
        material={materials['Material.023']}
        position={[-244.91, -6.15, -441.64]}
        rotation={[-1.54, 0.01, 0.29]}
        scale={[3.72, 4.4, 3.13]}
      />
      <group position={[-239.8, 11.62, -439.02]} rotation={[-1.33, 0.5, 0.33]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car004_1.geometry} material={materials['Steel_1.004']} />
        <mesh geometry={nodes.Car004_2.geometry} material={materials['White.004']} />
        <mesh geometry={nodes.Car004_3.geometry} material={materials['Black_Matte.004']} />
        <mesh geometry={nodes.Car004_4.geometry} material={materials['Cabin.004']} />
        <mesh geometry={nodes.Car004_5.geometry} material={materials['Steel.004']} />
      </group>
      <mesh
        geometry={nodes.Cylinder079.geometry}
        material={materials['Material.031']}
        position={[-263.18, -6.15, -428.18]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder078.geometry}
        material={materials['Material.030']}
        position={[-258.06, -6.15, -428.18]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder077.geometry}
        material={materials['Material.029']}
        position={[-260.54, -6.15, -431.42]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder076.geometry}
        material={materials['Material.028']}
        position={[-262.5, -1.59, -428.57]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[2.48, 2.76, 2.48]}
      />
      <group position={[-267.2, 11.62, -421.33]} rotation={[-1.05, -0.19, -1.09]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car005_1.geometry} material={materials['Steel_1.005']} />
        <mesh geometry={nodes.Car005_2.geometry} material={materials['White.005']} />
        <mesh geometry={nodes.Car005_3.geometry} material={materials['Black_Matte.005']} />
        <mesh geometry={nodes.Car005_4.geometry} material={materials['Cabin.005']} />
        <mesh geometry={nodes.Car005_5.geometry} material={materials['Steel.005']} />
      </group>
      <mesh
        geometry={nodes.Cube018.geometry}
        material={materials.trunk}
        position={[-273.59, -9.4, -391.73]}
        rotation={[-0.85, 0, 0]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cube019.geometry}
        material={materials['trunk.001']}
        position={[-273.59, -9.4, -436.76]}
        rotation={[-2.23, -0.33, -2.75]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cylinder072.geometry}
        material={materials['Material.024']}
        position={[-209.81, -2.3, -358.25]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder073.geometry}
        material={materials['Material.025']}
        position={[-205.83, -2.3, -358.25]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder074.geometry}
        material={materials['Material.026']}
        position={[-207.76, -2.3, -360.77]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder075.geometry}
        material={materials['Material.027']}
        position={[-209.28, 0.97, -358.55]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cube011.geometry}
        material={nodes.Cube011.material}
        position={[-236.68, 5.56, -326.59]}
        rotation={[0.22, 0, 0]}
        scale={[3.63, 3.39, 3.96]}
      />
      <mesh
        geometry={nodes.Cube009.geometry}
        material={nodes.Cube009.material}
        position={[-241.26, 1.5, -326.36]}
        rotation={[0.01, 0.22, 1.52]}
        scale={[2.99, 3.65, 3.63]}
      />
      <mesh
        geometry={nodes.Sphere018.geometry}
        material={nodes.Sphere018.material}
        position={[-236.39, -1.63, -328.09]}
        scale={[3.63, 2.97, 3.63]}
      />
      <mesh
        geometry={nodes.Cube013.geometry}
        material={nodes.Cube013.material}
        position={[-209.88, 1.5, -303.5]}
        rotation={[0.01, 0.22, 1.52]}
        scale={[2.99, 3.65, 3.63]}
      />
      <mesh
        geometry={nodes.Cube012.geometry}
        material={nodes.Cube012.material}
        position={[-205.3, 5.56, -303.73]}
        rotation={[0.22, 0, 0]}
        scale={[3.63, 3.39, 3.96]}
      />
      <mesh
        geometry={nodes.Sphere019.geometry}
        material={nodes.Sphere019.material}
        position={[-205.01, -1.63, -305.23]}
        scale={[3.63, 2.97, 3.63]}
      />
      <group position={[-209.82, -0.87, -319.11]} rotation={[-2.49, -0.02, -0.81]} scale={[-0.1, 0.09, 0.07]}>
        <mesh geometry={nodes.Car009_1.geometry} material={materials['Steel_1.009']} />
        <mesh geometry={nodes.Car009_2.geometry} material={materials['White.009']} />
        <mesh geometry={nodes.Car009_3.geometry} material={materials['Black_Matte.009']} />
        <mesh geometry={nodes.Car009_4.geometry} material={materials['Cabin.009']} />
        <mesh geometry={nodes.Car009_5.geometry} material={materials['Steel.009']} />
      </group>
      <group position={[-199.01, 10.96, -295.68]} rotation={[-1.33, 0.5, 0.33]} scale={[-0.09, 0.08, 0.07]}>
        <mesh geometry={nodes.Car008_1.geometry} material={materials['Steel_1.008']} />
        <mesh geometry={nodes.Car008_2.geometry} material={materials['White.008']} />
        <mesh geometry={nodes.Car008_3.geometry} material={materials['Black_Matte.008']} />
        <mesh geometry={nodes.Car008_4.geometry} material={materials['Cabin.008']} />
        <mesh geometry={nodes.Car008_5.geometry} material={materials['Steel.008']} />
      </group>
      <group position={[-220.3, 10.96, -281.93]} rotation={[-1.05, -0.19, -1.09]} scale={[-0.09, 0.08, 0.07]}>
        <mesh geometry={nodes.Car007_1.geometry} material={materials['Steel_1.007']} />
        <mesh geometry={nodes.Car007_2.geometry} material={materials['White.007']} />
        <mesh geometry={nodes.Car007_3.geometry} material={materials['Black_Matte.007']} />
        <mesh geometry={nodes.Car007_4.geometry} material={materials['Cabin.007']} />
        <mesh geometry={nodes.Car007_5.geometry} material={materials['Steel.007']} />
      </group>
      <mesh
        geometry={nodes.Cube025.geometry}
        material={nodes.Cube025.material}
        position={[-241.26, 1.5, -266.54]}
        rotation={[0.01, 0.22, 1.52]}
        scale={[2.99, 3.65, 3.63]}
      />
      <mesh
        geometry={nodes.Cube024.geometry}
        material={nodes.Cube024.material}
        position={[-236.68, 5.56, -266.77]}
        rotation={[0.22, 0, 0]}
        scale={[3.63, 3.39, 3.96]}
      />
      <mesh
        geometry={nodes.Cube023.geometry}
        material={nodes.Cube023.material}
        position={[-205.3, 5.56, -243.91]}
        rotation={[0.22, 0, 0]}
        scale={[3.63, 3.39, 3.96]}
      />
      <mesh
        geometry={nodes.Cube022.geometry}
        material={nodes.Cube022.material}
        position={[-209.88, 1.5, -243.68]}
        rotation={[0.01, 0.22, 1.52]}
        scale={[2.99, 3.65, 3.63]}
      />
      <mesh
        geometry={nodes.Cube021.geometry}
        material={materials['trunk.003']}
        position={[-225.27, -4.11, -258.93]}
        rotation={[-0.85, 0, 0]}
        scale={[1.92, 2.91, 2.89]}
      />
      <mesh
        geometry={nodes.Cube020.geometry}
        material={materials['trunk.002']}
        position={[-225.27, -4.11, -293.92]}
        rotation={[-2.23, -0.33, -2.75]}
        scale={[1.92, 2.91, 2.89]}
      />
      <mesh
        geometry={nodes.Cylinder114.geometry}
        material={materials['Material.072']}
        position={[-202.98, -1.78, -297.71]}
        rotation={[-1.54, 0.01, 0.29]}
        scale={[2.89, 3.42, 2.24]}
      />
      <mesh
        geometry={nodes.Cylinder113.geometry}
        material={materials['Material.071']}
        position={[-209.81, -2.3, -298.43]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder112.geometry}
        material={materials['Material.070']}
        position={[-205.83, -2.3, -298.43]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder111.geometry}
        material={materials['Material.069']}
        position={[-207.76, -2.3, -300.94]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder110.geometry}
        material={materials['Material.068']}
        position={[-209.28, 0.97, -298.73]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder109.geometry}
        material={materials['Material.067']}
        position={[-216.65, 1.49, -287.56]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder108.geometry}
        material={materials['Material.066']}
        position={[-215.13, -1.78, -289.77]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder107.geometry}
        material={materials['Material.065']}
        position={[-213.2, -1.78, -287.26]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Cylinder106.geometry}
        material={materials['Material.064']}
        position={[-217.18, -1.78, -287.26]}
        scale={[1.92, 1.97, 1.92]}
      />
      <mesh
        geometry={nodes.Sphere023.geometry}
        material={nodes.Sphere023.material}
        position={[-236.39, -1.63, -268.27]}
        scale={[3.63, 2.97, 3.63]}
      />
      <mesh
        geometry={nodes.Sphere022.geometry}
        material={nodes.Sphere022.material}
        position={[-205.01, -1.63, -245.41]}
        scale={[3.63, 2.97, 3.63]}
      />
      <group position={[-41.97, -4.89, 244.63]} rotation={[-2.49, -0.02, -0.81]} scale={[-0.18, 0.15, 0.12]}>
        <mesh geometry={nodes.Car012_1.geometry} material={materials['Steel_1.012']} />
        <mesh geometry={nodes.Car012_2.geometry} material={materials['White.012']} />
        <mesh geometry={nodes.Car012_3.geometry} material={materials['Black_Matte.012']} />
        <mesh geometry={nodes.Car012_4.geometry} material={materials['Cabin.012']} />
        <mesh geometry={nodes.Car012_5.geometry} material={materials['Steel.012']} />
      </group>
      <group position={[-28.06, 11.62, 274.79]} rotation={[-1.33, 0.5, 0.33]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car011_1.geometry} material={materials['Steel_1.011']} />
        <mesh geometry={nodes.Car011_2.geometry} material={materials['White.011']} />
        <mesh geometry={nodes.Car011_3.geometry} material={materials['Black_Matte.011']} />
        <mesh geometry={nodes.Car011_4.geometry} material={materials['Cabin.011']} />
        <mesh geometry={nodes.Car011_5.geometry} material={materials['Steel.011']} />
      </group>
      <group position={[-55.46, 11.62, 292.47]} rotation={[-1.05, -0.19, -1.09]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car010_1.geometry} material={materials['Steel_1.010']} />
        <mesh geometry={nodes.Car010_2.geometry} material={materials['White.010']} />
        <mesh geometry={nodes.Car010_3.geometry} material={materials['Black_Matte.010']} />
        <mesh geometry={nodes.Car010_4.geometry} material={materials['Cabin.010']} />
        <mesh geometry={nodes.Car010_5.geometry} material={materials['Steel.010']} />
      </group>
      <mesh
        geometry={nodes.Cube031.geometry}
        material={nodes.Cube031.material}
        position={[-82.43, -1.58, 312.29]}
        rotation={[0.01, 0.22, 1.52]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube030.geometry}
        material={nodes.Cube030.material}
        position={[-76.55, 4.08, 311.99]}
        rotation={[0.22, 0, 0]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube029.geometry}
        material={nodes.Cube029.material}
        position={[-36.16, 4.08, 341.41]}
        rotation={[0.22, 0, 0]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube028.geometry}
        material={nodes.Cube028.material}
        position={[-42.05, -1.58, 341.71]}
        rotation={[0.01, 0.22, 1.52]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube027.geometry}
        material={materials['trunk.005']}
        position={[-61.86, -9.4, 322.08]}
        rotation={[-0.85, 0, 0]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cube026.geometry}
        material={materials['trunk.004']}
        position={[-61.86, -9.4, 277.05]}
        rotation={[-2.23, -0.33, -2.75]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cylinder123.geometry}
        material={materials['Material.083']}
        position={[-33.17, -6.15, 272.16]}
        rotation={[-1.54, 0.01, 0.29]}
        scale={[3.72, 4.4, 3.13]}
      />
      <mesh
        geometry={nodes.Cylinder122.geometry}
        material={materials['Material.082']}
        position={[-41.96, -6.89, 271.25]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder121.geometry}
        material={materials['Material.081']}
        position={[-36.84, -6.89, 271.25]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder120.geometry}
        material={materials['Material.080']}
        position={[-39.32, -6.89, 268.01]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder119.geometry}
        material={materials['Material.079']}
        position={[-41.28, -2.32, 270.86]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder118.geometry}
        material={materials['Material.078']}
        position={[-50.76, -1.59, 285.24]}
        rotation={[0.03, -0.21, 0.02]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder117.geometry}
        material={materials['Material.077']}
        position={[-48.8, -6.15, 282.39]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder116.geometry}
        material={materials['Material.076']}
        position={[-46.32, -6.15, 285.62]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder115.geometry}
        material={materials['Material.075']}
        position={[-51.44, -6.15, 285.62]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Sphere025.geometry}
        material={nodes.Sphere025.material}
        position={[-76.17, -5.95, 310.06]}
        scale={[4.67, 4.14, 4.67]}
      />
      <mesh
        geometry={nodes.Sphere024.geometry}
        material={nodes.Sphere024.material}
        position={[-35.79, -5.95, 339.48]}
        scale={[4.67, 4.14, 4.67]}
      />
      <group position={[-157.42, -4.89, -444.23]} rotation={[-2.26, 0.67, -1.47]} scale={[-0.18, 0.15, 0.12]}>
        <mesh geometry={nodes.Car015_1.geometry} material={materials['Steel_1.015']} />
        <mesh geometry={nodes.Car015_2.geometry} material={materials['White.015']} />
        <mesh geometry={nodes.Car015_3.geometry} material={materials['Black_Matte.015']} />
        <mesh geometry={nodes.Car015_4.geometry} material={materials['Cabin.015']} />
        <mesh geometry={nodes.Car015_5.geometry} material={materials['Steel.015']} />
      </group>
      <group position={[-172.94, 11.62, -414.87]} rotation={[-1.03, 0.12, -0.56]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car014_1.geometry} material={materials['Steel_1.014']} />
        <mesh geometry={nodes.Car014_2.geometry} material={materials['White.014']} />
        <mesh geometry={nodes.Car014_3.geometry} material={materials['Black_Matte.014']} />
        <mesh geometry={nodes.Car014_4.geometry} material={materials['Cabin.014']} />
        <mesh geometry={nodes.Car014_5.geometry} material={materials['Steel.014']} />
      </group>
      <group position={[-203.63, 11.62, -425.93]} rotation={[-1.4, -0.53, -2.01]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car013_1.geometry} material={materials['Steel_1.013']} />
        <mesh geometry={nodes.Car013_2.geometry} material={materials['White.013']} />
        <mesh geometry={nodes.Car013_3.geometry} material={materials['Black_Matte.013']} />
        <mesh geometry={nodes.Car013_4.geometry} material={materials['Cabin.013']} />
        <mesh geometry={nodes.Car013_5.geometry} material={materials['Steel.013']} />
      </group>
      <mesh
        geometry={nodes.Cube037.geometry}
        material={nodes.Cube037.material}
        position={[-235.74, -1.58, -435.35]}
        rotation={[0.01, -0.7, 1.53]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube036.geometry}
        material={nodes.Cube036.material}
        position={[-231.93, 4.08, -430.85]}
        rotation={[0.35, -0.89, 0.27]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube035.geometry}
        material={nodes.Cube035.material}
        position={[-230.82, 4.08, -380.9]}
        rotation={[0.35, -0.89, 0.27]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube034.geometry}
        material={nodes.Cube034.material}
        position={[-234.63, -1.58, -385.4]}
        rotation={[0.01, -0.7, 1.53]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube033.geometry}
        material={materials['trunk.007']}
        position={[-231.04, -9.4, -413.05]}
        rotation={[-1.08, -0.56, -0.78]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cube032.geometry}
        material={materials['trunk.006']}
        position={[-195.24, -9.4, -440.37]}
        rotation={[-2.25, 0.27, 2.83]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cylinder132.geometry}
        material={materials['Material.094']}
        position={[-173.96, -6.15, -420.52]}
        rotation={[-1.55, -0.02, -0.63]}
        scale={[3.72, 4.4, 3.13]}
      />
      <mesh
        geometry={nodes.Cylinder131.geometry}
        material={materials['Material.093']}
        position={[-178.57, -6.89, -428.07]}
        rotation={[0, -0.92, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder130.geometry}
        material={materials['Material.092']}
        position={[-175.46, -6.89, -424]}
        rotation={[0, -0.92, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder129.geometry}
        material={materials['Material.091']}
        position={[-174.39, -6.89, -427.93]}
        rotation={[0, -0.92, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder128.geometry}
        material={materials['Material.090']}
        position={[-177.85, -2.32, -427.76]}
        rotation={[0.06, -1.12, 0.07]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder127.geometry}
        material={materials['Material.089']}
        position={[-195.03, -1.59, -426.58]}
        rotation={[0.06, -1.12, 0.07]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder126.geometry}
        material={materials['Material.088']}
        position={[-191.57, -6.15, -426.75]}
        rotation={[0, -0.92, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder125.geometry}
        material={materials['Material.087']}
        position={[-192.64, -6.15, -422.82]}
        rotation={[0, -0.92, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder124.geometry}
        material={materials['Material.086']}
        position={[-195.75, -6.15, -426.89]}
        rotation={[0, -0.92, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Sphere027.geometry}
        material={nodes.Sphere027.material}
        position={[-230.17, -5.95, -431.72]}
        rotation={[0, -0.92, 0]}
        scale={[4.67, 4.14, 4.67]}
      />
      <mesh
        geometry={nodes.Sphere026.geometry}
        material={nodes.Sphere026.material}
        position={[-229.06, -5.95, -381.77]}
        rotation={[0, -0.92, 0]}
        scale={[4.67, 4.14, 4.67]}
      />
      <group position={[-156.18, -4.89, -346.78]} rotation={[-1.77, 0.91, -2.14]} scale={[-0.18, 0.15, 0.12]}>
        <mesh geometry={nodes.Car018_1.geometry} material={materials['Steel_1.018']} />
        <mesh geometry={nodes.Car018_2.geometry} material={materials['White.018']} />
        <mesh geometry={nodes.Car018_3.geometry} material={materials['Black_Matte.018']} />
        <mesh geometry={nodes.Car018_4.geometry} material={materials['Cabin.018']} />
        <mesh geometry={nodes.Car018_5.geometry} material={materials['Steel.018']} />
      </group>
      <group position={[-184.29, 11.62, -329.1]} rotation={[-1.04, -0.15, -1.01]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car017_1.geometry} material={materials['Steel_1.017']} />
        <mesh geometry={nodes.Car017_2.geometry} material={materials['White.017']} />
        <mesh geometry={nodes.Car017_3.geometry} material={materials['Black_Matte.017']} />
        <mesh geometry={nodes.Car017_4.geometry} material={materials['Cabin.017']} />
        <mesh geometry={nodes.Car017_5.geometry} material={materials['Steel.017']} />
      </group>
      <group position={[-205.36, 11.62, -353.99]} rotation={[-1.72, -0.53, -2.62]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car016_1.geometry} material={materials['Steel_1.016']} />
        <mesh geometry={nodes.Car016_2.geometry} material={materials['White.016']} />
        <mesh geometry={nodes.Car016_3.geometry} material={materials['Black_Matte.016']} />
        <mesh geometry={nodes.Car016_4.geometry} material={materials['Cabin.016']} />
        <mesh geometry={nodes.Car016_5.geometry} material={materials['Steel.016']} />
      </group>
      <mesh
        geometry={nodes.Cube043.geometry}
        material={nodes.Cube043.material}
        position={[-228.49, -1.58, -378.18]}
        rotation={[0.03, -1.22, 1.55]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube042.geometry}
        material={nodes.Cube042.material}
        position={[-227.43, 4.08, -372.38]}
        rotation={[1.04, -1.32, 1.03]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube041.geometry}
        material={nodes.Cube041.material}
        position={[-251.4, 4.08, -328.54]}
        rotation={[1.04, -1.32, 1.03]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube040.geometry}
        material={nodes.Cube040.material}
        position={[-252.45, -1.58, -334.33]}
        rotation={[0.03, -1.22, 1.55]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube039.geometry}
        material={materials['trunk.009']}
        position={[-235.54, -9.4, -356.51]}
        rotation={[-1.46, -0.72, -1.4]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cube038.geometry}
        material={materials['trunk.008']}
        position={[-190.89, -9.4, -362.32]}
        rotation={[-2.06, 0.56, 2.35]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cylinder141.geometry}
        material={materials['Material.105']}
        position={[-182.35, -6.15, -334.5]}
        rotation={[-1.56, -0.02, -1.16]}
        scale={[3.72, 4.4, 3.13]}
      />
      <mesh
        geometry={nodes.Cylinder140.geometry}
        material={materials['Material.104']}
        position={[-182.57, -6.89, -343.34]}
        rotation={[0, -1.44, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder139.geometry}
        material={materials['Material.103']}
        position={[-181.91, -6.89, -338.26]}
        rotation={[0, -1.44, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder138.geometry}
        material={materials['Material.102']}
        position={[-179.02, -6.89, -341.14]}
        rotation={[0, -1.44, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder137.geometry}
        material={materials['Material.101']}
        position={[-182.1, -2.32, -342.71]}
        rotation={[2.82, -1.49, 2.84]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder136.geometry}
        material={materials['Material.100']}
        position={[-197.58, -1.59, -350.26]}
        rotation={[2.82, -1.49, 2.84]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder135.geometry}
        material={materials['Material.099']}
        position={[-194.5, -6.15, -348.69]}
        rotation={[0, -1.44, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder134.geometry}
        material={materials['Material.098']}
        position={[-197.39, -6.15, -345.81]}
        rotation={[0, -1.44, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder133.geometry}
        material={materials['Material.097']}
        position={[-198.05, -6.15, -350.89]}
        rotation={[0, -1.44, 0]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Sphere029.geometry}
        material={nodes.Sphere029.material}
        position={[-225.47, -5.95, -372.25]}
        rotation={[0, -1.44, 0]}
        scale={[4.67, 4.14, 4.67]}
      />
      <mesh
        geometry={nodes.Sphere028.geometry}
        material={nodes.Sphere028.material}
        position={[-249.44, -5.95, -328.41]}
        rotation={[0, -1.44, 0]}
        scale={[4.67, 4.14, 4.67]}
      />
      <group position={[3.54, 11.62, 299.05]} rotation={[-1.47, 0.54, 0.61]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car021_1.geometry} material={materials['Steel_1.021']} />
        <mesh geometry={nodes.Car021_2.geometry} material={materials['White.021']} />
        <mesh geometry={nodes.Car021_3.geometry} material={materials['Black_Matte.021']} />
        <mesh geometry={nodes.Car021_4.geometry} material={materials['Cabin.021']} />
        <mesh geometry={nodes.Car021_5.geometry} material={materials['Steel.021']} />
      </group>
      <group position={[-19.31, 11.62, 275.77]} rotation={[-2.11, 0.11, 2.19]} scale={[-0.14, 0.12, 0.12]}>
        <mesh geometry={nodes.Car020_1.geometry} material={materials['Steel_1.020']} />
        <mesh geometry={nodes.Car020_2.geometry} material={materials['White.020']} />
        <mesh geometry={nodes.Car020_3.geometry} material={materials['Black_Matte.020']} />
        <mesh geometry={nodes.Car020_4.geometry} material={materials['Cabin.020']} />
        <mesh geometry={nodes.Car020_5.geometry} material={materials['Steel.020']} />
      </group>
      <group position={[-46.04, -4.89, 295.48]} rotation={[-1.28, -0.89, 1.12]} scale={[-0.18, 0.15, 0.12]}>
        <mesh geometry={nodes.Car019_1.geometry} material={materials['Steel_1.019']} />
        <mesh geometry={nodes.Car019_2.geometry} material={materials['White.019']} />
        <mesh geometry={nodes.Car019_3.geometry} material={materials['Black_Matte.019']} />
        <mesh geometry={nodes.Car019_4.geometry} material={materials['Cabin.019']} />
        <mesh geometry={nodes.Car019_5.geometry} material={materials['Steel.019']} />
      </group>
      <mesh
        geometry={nodes.Cube049.geometry}
        material={materials['trunk.011']}
        position={[-10.29, -9.4, 308.42]}
        rotation={[-1.05, -0.53, -0.72]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cube048.geometry}
        material={materials['trunk.010']}
        position={[33.82, -9.4, 299.35]}
        rotation={[-1.75, 0.71, 1.84]}
        scale={[2.47, 5.1, 5.17]}
      />
      <mesh
        geometry={nodes.Cube047.geometry}
        material={nodes.Cube047.material}
        position={[49.06, -1.58, 276]}
        rotation={[3.11, 1.15, -1.6]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cube046.geometry}
        material={nodes.Cube046.material}
        position={[47.58, 4.08, 270.29]}
        rotation={[2.31, 1.28, -2.33]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube045.geometry}
        material={nodes.Cube045.material}
        position={[26.9, 4.08, 315.77]}
        rotation={[2.31, 1.28, -2.33]}
        scale={[4.67, 5.06, 5.37]}
      />
      <mesh
        geometry={nodes.Cube044.geometry}
        material={nodes.Cube044.material}
        position={[28.38, -1.58, 321.48]}
        rotation={[3.11, 1.15, -1.6]}
        scale={[4.19, 4.71, 4.68]}
      />
      <mesh
        geometry={nodes.Cylinder150.geometry}
        material={materials['Material.114']}
        position={[-3.98, -6.15, 296.5]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder149.geometry}
        material={materials['Material.113']}
        position={[-5.01, -6.15, 291.48]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder148.geometry}
        material={materials['Material.112']}
        position={[-7.68, -6.15, 294.56]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder147.geometry}
        material={materials['Material.111']}
        position={[-4.5, -1.59, 295.91]}
        rotation={[1.44, 1.55, -1.42]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder146.geometry}
        material={materials['Material.110']}
        position={[-20.49, -2.32, 289.52]}
        rotation={[1.44, 1.55, -1.42]}
        scale={[2.48, 2.76, 2.48]}
      />
      <mesh
        geometry={nodes.Cylinder145.geometry}
        material={materials['Material.109']}
        position={[-23.67, -6.89, 288.17]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder144.geometry}
        material={materials['Material.108']}
        position={[-21, -6.89, 285.09]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder143.geometry}
        material={materials['Material.107']}
        position={[-19.97, -6.89, 290.1]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[2.47, 2.75, 2.47]}
      />
      <mesh
        geometry={nodes.Cylinder142.geometry}
        material={materials['Material.106']}
        position={[-20.85, -6.15, 281.31]}
        rotation={[-1.58, 0.02, 2.06]}
        scale={[3.72, 4.4, 3.13]}
      />
      <mesh
        geometry={nodes.Sphere031.geometry}
        material={nodes.Sphere031.material}
        position={[45.62, -5.95, 270.31]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[4.67, 4.14, 4.67]}
      />
      <mesh
        geometry={nodes.Sphere030.geometry}
        material={nodes.Sphere030.material}
        position={[24.93, -5.95, 315.79]}
        rotation={[-Math.PI, 1.37, -Math.PI]}
        scale={[4.67, 4.14, 4.67]}
      />
      <mesh
        geometry={nodes.Cube005.geometry}
        material={materials.red}
        position={[258.03, 31.41, 209.72]}
        scale={[81.42, 43.71, 97.05]}
      />
      <mesh
        geometry={nodes.Cylinder054.geometry}
        material={materials['Material.004']}
        position={[211.07, 66.05, 271.19]}
        scale={[19.9, 30.9, 19.91]}
      />
      <mesh
        geometry={nodes.Cylinder053.geometry}
        material={nodes.Cylinder053.material}
        position={[272, 66.77, 268.89]}
        scale={[6.06, 30.9, 6.06]}
      />
      <mesh
        geometry={nodes.Cylinder052.geometry}
        material={nodes.Cylinder052.material}
        position={[309.5, 66.45, 268.2]}
        scale={[6.06, 30.9, 6.06]}
      />
      <mesh
        geometry={nodes.Sphere003.geometry}
        material={nodes.Sphere003.material}
        position={[226.13, 115.2, 270.83]}
        scale={[15.86, 7.13, 16.17]}>
        <mesh geometry={nodes.Sphere.geometry} material={nodes.Sphere.material} position={[-0.9, -1.75, 0.85]} />
        <mesh
          geometry={nodes.Sphere001.geometry}
          material={nodes.Sphere001.material}
          position={[0.42, -1.28, 0.44]}
          scale={[1.14, 1.14, 1.14]}
        />
        <mesh geometry={nodes.Sphere002.geometry} material={nodes.Sphere002.material} position={[1.35, 0.25, 0.47]} />
        <mesh geometry={nodes.Sphere004.geometry} material={nodes.Sphere004.material} position={[1.02, 1.36, -0.04]} />
      </mesh>
      <mesh
        geometry={nodes.Sphere005.geometry}
        material={nodes.Sphere005.material}
        position={[226.13, 115.2, 270.83]}
        scale={[15.86, 7.13, 16.17]}
      />
      <mesh
        geometry={nodes.Sphere009.geometry}
        material={nodes.Sphere009.material}
        position={[282.36, 110.75, 262.03]}
        scale={[9.52, 5.55, 10.57]}>
        <mesh geometry={nodes.Sphere006.geometry} material={nodes.Sphere006.material} position={[-0.9, -1.75, 0.85]} />
        <mesh
          geometry={nodes.Sphere007.geometry}
          material={nodes.Sphere007.material}
          position={[0.42, -1.28, 0.44]}
          scale={[1.14, 1.14, 1.14]}
        />
        <mesh geometry={nodes.Sphere008.geometry} material={nodes.Sphere008.material} position={[1.35, 0.25, 0.47]} />
        <mesh geometry={nodes.Sphere010.geometry} material={nodes.Sphere010.material} position={[1.02, 1.36, -0.04]} />
      </mesh>
      <mesh
        geometry={nodes.Sphere011.geometry}
        material={nodes.Sphere011.material}
        position={[284.79, 115.51, 262.03]}
        scale={[15.86, 7.13, 16.17]}
      />
      <mesh
        geometry={nodes.Sphere015.geometry}
        material={nodes.Sphere015.material}
        position={[321.99, 107, 255.51]}
        scale={[11.19, 4.61, 11.92]}>
        <mesh geometry={nodes.Sphere012.geometry} material={nodes.Sphere012.material} position={[-0.9, -1.75, 0.85]} />
        <mesh
          geometry={nodes.Sphere013.geometry}
          material={nodes.Sphere013.material}
          position={[0.42, -1.28, 0.44]}
          scale={[1.14, 1.14, 1.14]}
        />
        <mesh geometry={nodes.Sphere014.geometry} material={nodes.Sphere014.material} position={[1.35, 0.25, 0.47]} />
        <mesh geometry={nodes.Sphere016.geometry} material={nodes.Sphere016.material} position={[1.02, 1.36, -0.04]} />
      </mesh>
      <mesh
        geometry={nodes.Sphere017.geometry}
        material={nodes.Sphere017.material}
        position={[321.99, 107, 255.51]}
        scale={[11.19, 4.61, 11.92]}
      />
    </group>
  )
}

useGLTF.preload('assets/models/cityBad.glb')
